module.exports = __webpack_public_path__ + "static/media/badge-1.9c279ce7.svg";